import axios from 'axios';
import { cachetime } from '../config';

export default function() {
  return {
    namespaced: true,
    state: {
      delegations: {},
    },
    mutations: {
      SET_DELEGATIONS(state, { data, locale }) {
        state.delegations = {
          ...state.delegations,
          [locale]: {
            data,
            __updatedAt: Date.now(),
          }
        }
      }
    },
    actions: {
      FETCH_DELEGATIONS({ state, commit }, { locale }) {
        if (state.delegations[locale] 
          && state.delegations[locale].data
          && Date.now() - state.delegations[locale].__updatedAt < cachetime
        ) {
          return ;
        }

        return axios.get('/api/delegations')
          .then((res) => {
            const data = res.data || {};
            commit('SET_DELEGATIONS', { data, locale});
          }).catch(err => console.log(err));
      }
    },
    getters: {
      getDelegations: (state) => (locale) => {
        return state.delegations[locale] ? state.delegations[locale].data || {} : {};
      }
    }
  }
};